import ActiveRecord from './active_record/base'
import {date} from '@eitje/utils'

class Event extends ActiveRecord {
	static tableName = 'events'
	static defaultJoins = ['eventTypes', 'eventSeries']
	static sort = ['date', 'title']

	constructor(props) {
		super(props)
		this.dates = [props.date]
		this.isSeries = !!this.event_series_id
	}

	inPast() {
		return date(`${this.date} ${this.till || '23:59'}`).inPast()
	}
}

export default Event
